export const CONSTANTS = {
  HBS_CUSTSERVEITEM_VIEW: 'ComponentData',
  HBS_BIKE: 'Bike',
  HBS_BIKE_ITEM: 'Item',
  HBS_BIKE_SERIAL_NO: 'SerialNo',
  HBS_HEADERS: 'Headers',
  HBS_HEADER_NO: 'Header_No',
  HBS_PRODUCT_GROUPS: 'groups',
  HBS_PRODUCT_GROUP_NO: 'GroupItem_No',
  HBS_PRODUCT_GROUP_DESC: 'GroupItem_Descr',
  HBS_PRODUCT_PARTS: 'parts',
  HBS_PRODUCT_NO: 'Item_No',
  HBS_PRODUCT_DESC: 'Item_Descr',
  HBS_COMPONENT: 'Komponente',
  HBS_PRODUCT_Nr: 'Nr',
  HBS_PRODUCT_QUANTITY: 'UsedQuantity',
  HBS_PRODUCT_HIERARCHY: 'hierarchy',
  HBS_DESCRIPTION: 'Description',
  HBS_COUNT: 'count',
  HBS_IMAGE: 'image',
}
